export default __webpack_public_path__ + "static/media/floor-resurfacing.0dce4a13.png";